import { AfterViewChecked, Component, DoCheck, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { MensagemChamado } from 'src/app/admihair/api/dto/mensagem-chamado';
import { MensagemChamadoService } from 'src/app/admihair/service/mensagem-chamado.service';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';

import { Client, IMessage } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { UrlServidor } from 'src/app/admihair/util/url-servidor';
import { ArquivoAnexo } from 'src/app/admihair/api/file/arquivo-anexo';

@Component({
  selector: 'app-chamado-franquia-chat',
  templateUrl: './chamado-franquia-chat.component.html',
  styleUrls: ['./chamado-franquia-chat.component.scss']
})
export class ChamadoFranquiaChatComponent extends AdmihairBaseComponent implements OnInit, OnDestroy, DoCheck {


  emojis = [
    '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜', '😝', '😛',
    '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐', '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡', '🤬', '😔',
    '😟', '😠', '😡', '🤬', '😔', '😕', '🙁', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤', '🎂'
  ];

  @ViewChild('chatWindow') private chatWindow!: ElementRef;

  progressoRequisicao: boolean = false;
  textContent: string = '';
  listaMensagensChamado: MensagemChamado[] = [];
  ultimaQuantidadeMensagens: number = 0;
  chamadoSelecionado?: ChamadoSuporte;
  exibirBotaoEncerrar: boolean = false;
  mostrarDialogDetalheChamado: boolean = false;

  stompClient!: Client;

  primeiraMensagemChat: boolean = false;
  
  mostrarDialogUpload: boolean = false;
  progressoSalvarAnexo: boolean = false;
  listaMensagensArquivos: MensagemChamado[] = [];
  arquivosProcessando: number = 0;
  arquivosAnexados: ArquivoAnexo[] = [];
  maxFileSizeMB = 3;
  validTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv'
  ];

  constructor(private mensagemChamadoService: MensagemChamadoService,
    private chamadoService: ChamadoSuporteService,
    private sanitizer: DomSanitizer,
    private localStorage: UtilStorageService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.carregarChamadoSuporte();
    this.conectarWebSocket();
  }

  ngOnDestroy(): void {
    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
    }
  }

  ngDoCheck(): void {
    if (this.listaMensagensChamado.length !== this.ultimaQuantidadeMensagens) {
      this.ultimaQuantidadeMensagens = this.listaMensagensChamado.length;
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  private scrollToBottom(): void {
    const chat = this.chatWindow.nativeElement;
    chat.scrollTop = chat.scrollHeight;
  }

  conectarWebSocket(): void {
    const token = this.localStorage.getToken(); // JWT
    const socketUrl = `${UrlServidor.URL_BASE}ws-chat?token=${token}`;

    this.stompClient = new Client({
      webSocketFactory: () => new SockJS(socketUrl),
      reconnectDelay: 5000
    });

    this.stompClient.onConnect = () => {
      const chatId = 'chamado-' + this.idParametroUrl;
      this.stompClient.subscribe(`/topico/chat/${chatId}`, (message: IMessage) => {
        const novaMensagem = JSON.parse(message.body);
        if (novaMensagem.chamadoSuporte.status !== 'ABERTO'
           || novaMensagem.chamadoSuporte.status !== 'RECEBIDO') {
            this.primeiraMensagemChat = false;
            console.log('primeira mensagem marcada como falso')
        }
        this.listaMensagensChamado.push(novaMensagem);
      });
    };

    this.stompClient.onStompError = (frame) => {
      console.error('Erro no STOMP:', frame.headers['message'], frame.body);
    };

    this.stompClient.activate();
  }

  enviarMensagem(mensagem: MensagemChamado): void {
    this.stompClient.publish({
      destination: '/app/chat/enviar',
      body: JSON.stringify(mensagem)
    });
    this.textContent = '';
  }


  carregarChamadoSuporte() {
    this.chamadoService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: ChamadoSuporte) => {
        this.chamadoSelecionado = data;
        this.validarPrimeiraMensagem();
        this.verifificarExibirBotaoEncerrar();
        this.carregarMensagens();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  validarPrimeiraMensagem() {
    if (this.chamadoSelecionado?.status === 'ABERTO' 
      || this.chamadoSelecionado?.status === 'RECEBIDO') {
        this.primeiraMensagemChat = true;
    }
  }

  verifificarExibirBotaoEncerrar() {
    if (this.chamadoSelecionado?.solicitado === 'FRANQUIA' &&
       (this.chamadoSelecionado.status === 'ABERTO' ||
        this.chamadoSelecionado.status === 'RECEBIDO' ||
        this.chamadoSelecionado.status === 'EM_ATENDIMENTO'
       )) {
      this.exibirBotaoEncerrar = true;
    } else {
      this.exibirBotaoEncerrar = false;
    }
  }

  carregarMensagens() {
    this.mensagemChamadoService.listarPoChamadoId(this.chamadoSelecionado?.id).subscribe({
      next: (data: MensagemChamado[]) => {
        this.listaMensagensChamado = data;
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  sendMessage() {
    if (this.textContent == '' || this.textContent === ' ') {
      return;
    }
    else {
      const usuario = this.getUsuarioLogadoSistema();
      let mensagem: MensagemChamado = {
        chamadoSuporte: this.chamadoSelecionado,
        conteudo: this.textContent,
        usuario: usuario,
        tipoMensagem: 'TEXTO',
        categoria: 'CONVERSA',
        primeiraMensagem: this.primeiraMensagemChat
      };
      this.enviarMensagem(mensagem);
      this.textContent = '';
    }
  }

  encerrarChamado() {
    this.redirecionarPagina('/rfarias/suporte/encerrar/' + this.chamadoSelecionado?.id);
  }

  abrirDialogUpload() {
    this.mostrarDialogUpload = true;
  }

  abrirDialogDetalheChamado() {
    this.mostrarDialogDetalheChamado = true;
  }

  abrirImagem(imagemBase64?: string) {
    if (imagemBase64) {
      const novaJanela = window.open();
      if (novaJanela) {
        novaJanela.document.write(`
          <html>
            <head><title>Visualizar Imagem</title></head>
            <body style="margin:0">
              <img src="${imagemBase64}" style="width:auto; height:auto; display:block;"/>
            </body>
          </html>
        `);
      }
    }
  }

  onEmojiSelect(emoji: string) {
    this.textContent += emoji;
  }

  salvarAnexos() {
    this.progressoSalvarAnexo = true;

    this.mensagemChamadoService.salvarListaMensagensAnexadas(this.listaMensagensArquivos).subscribe({
      next: () => {
        this.progressoSalvarAnexo = false;
        this.mostrarDialogUpload = false;
        this.arquivosAnexados = [];
        this.listaMensagensArquivos = [];
      },
      error: (err: any) => {
        this.progressoSalvarAnexo = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  addFile(file: File) {
    this.arquivosProcessando++;

    const tipoArquivo = this.obterTipoArquivo(file);
    const nomeArquivo = file.name;

    this.fileToBase64(file).then(base64 => {
      const mensagem: MensagemChamado = {
        chamadoSuporte: this.chamadoSelecionado,
        conteudo: base64,
        usuario: this.getUsuarioLogadoSistema(),
        tipoMensagem: tipoArquivo,
        categoria: 'CONVERSA',
        nomeArquivo: file.name
      };

      this.listaMensagensArquivos.push(mensagem);

      const isImagem = tipoArquivo === 'IMAGEM';

      this.arquivosAnexados.push(
        {
          preview: isImagem ? this.sanitizer
            .bypassSecurityTrustUrl(URL.createObjectURL(file)) : undefined,
          mensagem: mensagem,
          nome: nomeArquivo,
          icone: !isImagem ? this.obterIconeArquivo(tipoArquivo) : undefined
        }
      )

    }).catch(error => {
      console.error('Erro ao processar arquivo:', error);
    }).finally(() => {
      this.arquivosProcessando--;
    });
  }

  onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          const validacao = this.validarArquivo(file);
          if (validacao.valido) {
            this.addFile(file);
          } else {
            this.exibirMensagemErroArquivo(validacao.mensagemErro);
          }
        }

      }
    }
  }

  onFileSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      Array.from(target.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
      target.value = '';
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      Array.from(event.dataTransfer.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  removerArquivo(index: number) {
    const arquivo = this.arquivosAnexados[index];
    const i = this.listaMensagensChamado.indexOf(arquivo.mensagem);
    if (i >= 0) {
      this.listaMensagensChamado.splice(i, 1);
    }
    this.arquivosAnexados.splice(index, 1);
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  isValidFile(file: File): boolean {
    const isTypeValid = this.validTypes.includes(file.type);
    const isSizeValid = file.size <= this.maxFileSizeMB * 1024 * 1024;
    return isTypeValid && isSizeValid;
  }

  validarArquivo(file: File): { valido: boolean, mensagemErro?: string } {
    const tamanhoMaximoBytes = this.maxFileSizeMB * 1024 * 1024;

    const extensao = file.name.split('.').pop()?.toUpperCase() || 'DESCONHECIDO';

    if (!this.validTypes.includes(file.type)) {
      return {
        valido: false,
        mensagemErro: `Tipo de arquivo "${extensao}" não é permitido. Aceitamos imagens, PDF, DOCX e CSV.`
      };
    }

    if (file.size > tamanhoMaximoBytes) {
      return {
        valido: false,
        mensagemErro: `O arquivo "${file.name}" excede o tamanho máximo permitido de ${this.maxFileSizeMB}MB.`
      };
    }

    return { valido: true };
  }

  exibirMensagemErroArquivo(error?: string) {
    this.messagesDialog = [{
      severity: 'warn', summary: 'Anexo inválido:',
      detail: error ? error : 'Erro ao anexar'
    }];
    this.messagemVisivelDialog = true;
  }

  private obterTipoArquivo(file: File): string {
    const tipoMime = file.type;
    const extensao = file.name.split('.').pop()?.toLowerCase() || '';

    if (tipoMime.startsWith('image/')) {
      return 'IMAGEM';
    }

    switch (extensao) {
      case 'pdf':
        return 'PDF';
      case 'csv':
        return 'CSV';
      case 'docx':
        return 'DOCX';
      default:
        return 'DOCUMENTO';
    }
  }

  obterIconeArquivo(tipo?: string) {
    switch (tipo) {
      case 'IMAGEM':
        return 'pi pi-image';
      case 'PDF':
        return 'pi pi-file-pdf';
      case 'CSV':
        return 'pi pi-file-excel';
      case 'DOCX':
        return 'pi pi-file';
      default:
        return 'pi pi-file';
    }
  }

  obterMimeTypeBase64(base64: string): string {
    const result = /^data:(.*?);base64,/.exec(base64);
    return result ? result[1] : 'application/octet-stream';
  }

  baixarArquivo(base64?: string, nomeArquivo?: string) {
    if (!base64 || !nomeArquivo) {
      console.error('Base64 ou nome do arquivo não fornecidos.');
      return;
    }
    const mimeType = this.obterMimeTypeBase64(base64);
    const byteCharacters = atob(base64.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nomeArquivo;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  baixarArquivoUrl(url?: string) {
    if(url) {
      window.open(url, '_blank');
    }
  }

}
